import {Container, ItemImg, ItemText, ItemTitle, List, ListItem, Wrap} from "./styled";
import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {useImageUrl} from "../../../queries";

const WhyUsCard = ({card}) => {
    const imageUrl = useImageUrl(card?.item?.image);

    return (
        <ListItem>
            <ItemImg src={imageUrl}/>
            <ItemTitle>{card?.item?.title}</ItemTitle>
            <ItemText>{card?.item?.description}</ItemText>
        </ListItem>
    );
};

export const WhyUs = ({data}) => {
    const whyOurTitle = data?.why_our_title || "";
    const whyOurCards = data?.our_cards || [];

    return (
        <Container>
            <Wrap>
                <SectionTitle>{whyOurTitle}</SectionTitle>
                <List>
                    {whyOurCards.map((card, index) => (
                        <WhyUsCard key={index} card={card} />
                    ))}
                </List>
            </Wrap>
        </Container>
    )
}
